const INITIAL_COUNTER = 10_000;
const MS_IN_DAY = 86_400_000;
const MIN_COUNTER = 4;

const EASING_FUNCTIONS = {
  easeFastEnds: (p) => 1 - (p + Math.sin(2 * Math.PI * p) / (2 * Math.PI)),
  sCurve: (p) => 1 - (3 * p * p - 2 * p * p * p),
  linear: (p) => 1 - p,
  quadraticOut: (p) => 1 - p * p,
  exponentialOut: (p) => Math.pow(2, -10 * p),
  power16: (p) => Math.pow(1 - p, 1.6),
  power18: (p) => Math.pow(1 - p, 1.8),
};

function msSinceUtcMidnight(now = Date.now()) {
  const d = new Date(now);
  d.setUTCHours(0, 0, 0, 0);
  return now - d.getTime();
}

function toUtcMidnightMs(dateLike) {
  const d = new Date(dateLike);
  d.setUTCHours(0, 0, 0, 0);
  return d.getTime();
}

function getCurrentCounter(
  now = Date.now(),
  startDate = null,
  endDate = null,
  easingName = "power18",
  number = INITIAL_COUNTER,
  dailyTimeStr = null, // New parameter
) {
  const nowMs = new Date(now).getTime();
  const finalDeadline = new Date(endDate).getTime();
  const startMs = new Date(startDate).getTime();

  // 1. Global Guardrails
  if (nowMs < startMs) return number;
  if (nowMs >= finalDeadline) return 0;

  let currentCycleStart;
  let currentCycleEnd;

  if (dailyTimeStr) {
    // 2. Daily Logic: Find the "Current 24h Window"
    const [targetHour, targetMinute] = dailyTimeStr.split(":").map(Number);

    let anchor = new Date(nowMs);
    anchor.setHours(targetHour, targetMinute, 0, 0);

    if (nowMs >= anchor.getTime()) {
      // We are past today's 11:00, so the cycle started today at 11:00
      currentCycleStart = anchor.getTime();
    } else {
      // We are before today's 11:00, so the cycle started yesterday at 11:00
      anchor.setDate(anchor.getDate() - 1);
      currentCycleStart = anchor.getTime();
    }

    currentCycleEnd = currentCycleStart + MS_IN_DAY;

    // 3. Ensure we don't calculate past the actual campaign end
    if (currentCycleEnd > finalDeadline) {
      currentCycleEnd = finalDeadline;
    }
  } else {
    // 4. Legacy Logic: Use the whole campaign duration
    currentCycleStart = startMs;
    currentCycleEnd = finalDeadline;
  }

  const duration = currentCycleEnd - currentCycleStart;
  const elapsed = nowMs - currentCycleStart;
  const progress = Math.max(0, Math.min(1, elapsed / duration));

  const easing = EASING_FUNCTIONS[easingName] ?? EASING_FUNCTIONS.sCurve;
  const remainingPercent = easing(progress);

  return Math.max(0, Math.floor(number * remainingPercent));
}

function itemsLeftCounter(
  id,
  {
    startDate = null,
    endDate = null,
    easingName = "power18",
    number = INITIAL_COUNTER,
    min = MIN_COUNTER,
    dailyTimeStr = null,
  } = {},
) {
  const $out = document.getElementById(id);
  if (!$out) return;

  (function tick() {
    const raw = getCurrentCounter(
      Date.now(),
      startDate,
      endDate,
      easingName,
      number,
      dailyTimeStr,
    );
    const value = Math.max(min, raw);

    $out.textContent = value.toLocaleString("en-US");

    // Keep ticking if the campaign isn't over
    if (Date.now() < new Date(endDate).getTime()) {
      setTimeout(tick, 1000);
    }
  })();
}
